// Trilingual content for QHHT Barcelona - Danwei Huang
// Focused exclusively on QHHT (Quantum Healing Hypnosis Technique)
export const translations = {
  es: {
    nav: {
      therapies: "Terapias",
      qhht: "QHHT",
      session: "La sesión",
      process: "Proceso",
      group: "Grupal",
      about: "Sobre mí",
      contact: "Contacto",
      book: "Reservar 15 min gratis",
    },
    hero: {
      overline: "Hipnosis Cuántica · Barcelona",
      title: "Regresa al origen.\nDespierta tu luz interior.",
      description:
        "Tres caminos para reconectar contigo: Hipnosis Cuántica QHHT, Limpieza Energética e Hipnosis Regresiva.",
      primaryCta: "Entrevista gratuita",
      secondaryCta: "Conocer las terapias",
      location: "C/ Dos de Maig 202 · Barcelona",
    },
    yuan: {
      overline: "源 Yuan · La fuente",
      title: "El origen de toda sanación\nvive dentro de ti.",
      body:
        "源 (Yuan) es una palabra china que significa «fuente» o «origen». En cada sesión de QHHT te acompaño a descubrir tu verdadero poder, volver a encender esa luz divina en tu corazón y ver tu realidad desde otro nivel de conciencia. La emoción es la brújula, el subconsciente la respuesta.",
      pillars: [
        { title: "Consciencia", desc: "Despertar a la verdad que habita en ti." },
        { title: "Transformación", desc: "Liberar bloqueos emocionales desde la raíz." },
        { title: "Integración", desc: "Unir cuerpo, mente y espíritu en el presente." },
      ],
    },
    therapies: {
      overline: "Terapias",
      title: "Tres caminos,\nun mismo origen.",
      headerCta: "Reservar 15 min · llamada gratuita",
      intro:
        "Cada sesión es un viaje único. Elige el sendero que resuena con el momento que atraviesas. Todas las terapias comienzan con una entrevista gratuita de 15 minutos.",
      meditationAudio: {
        overline: "Audio meditación · gratuito",
        title: "Meditaciones guiadas",
        desc: "Empieza a reconectar contigo desde casa con mis meditaciones gratuitas en YouTube.",
        cta: "Escuchar en YouTube",
        url: "https://www.youtube.com/channel/UCL5PeCyiCxD7GAZfkjzUkZQ",
      },
      payCta: "Pagar sesión",
      bookCta: "Entrevista gratuita",
      detailCta: "Ver detalle",
      items: [
        {
          tag: "01",
          title: "Hipnosis Cuántica QHHT",
          desc:
            "Técnica desarrollada por Dolores Cannon tras 50 años de experiencia. Accedemos al subconsciente profundo —la esencia— donde residen todas las respuestas y donde la sanación física, emocional y espiritual es posible.",
          meta: "4 h mínimo · Presencial · 222 €",
          highlights: ["Certificada en QHHT Nivel 2", "Grabación incluida", "Reserva 44,40 € (20 %)"],
          primary: { type: "anchor", href: "#session", label: "Ver detalle de la sesión" },
          secondary: { type: "paypal", amount: "44.40", item: "Reserva sesion QHHT 20 por ciento - Danwei Huang", label: "Reservar sesión QHHT · 44,40 €" },
        },
        {
          tag: "02",
          title: "Limpieza Energética",
          desc:
            "Terapia energética sutil que actúa sobre tu campo informacional. Liberamos bloqueos generados por emociones repetidas, traumas no resueltos o pensamientos que quedan atrapados en el cuerpo o en un espacio. Trabajo siempre a distancia: con tu nombre completo, fecha y lugar de nacimiento —o la dirección si es un local—, conecto con tu esencia o la energía acumulada del lugar. La sesión dura aproximadamente una hora; tú puedes descansar o continuar con tu día.",
          meta: "Solo a distancia · 80 €",
          highlights: [
            "Personas, niños y mascotas",
            "Hogares, locales y negocios",
            "Trabajo a distancia",
            "Alivio físico, emocional y energético",
            "Mensaje final con lo trabajado",
          ],
          primary: { type: "paypal", amount: "80.00", item: "Limpieza Energetica - Danwei Huang", label: "Pagar sesión · 80 €" },
        },
        {
          tag: "03",
          title: "Hipnosis Regresiva",
          desc:
            "Detrás de cada miedo, síntoma o patrón que se repite hoy, hay una experiencia del pasado pidiendo ser comprendida. A través de una hipnosis suave y consciente, viajamos hasta esa raíz emocional —ya sea de esta vida o de otras— para sanarla e integrarla en el presente con tu mirada adulta de hoy, sin necesidad de revivir el dolor. Combina hipnosis ericksoniana, hipnosis introspectiva de Aurelio Mejía y PNL.",
          meta: "1 hora · Online o Presencial · 80 €",
          highlights: [
            "Un asunto o etapa por sesión",
            "Sin revivir el trauma con dolor",
            "Comprende tu pasado con otra conciencia",
            "Transformación consciente y duradera",
            "Online o presencial",
          ],
          primary: { type: "paypal", amount: "80.00", item: "Hipnosis Regresiva - Danwei Huang", label: "Pagar sesión · 80 €" },
        },
      ],
    },
    qhht: {
      overline: "Quantum Healing Hypnosis Technique",
      title: "Una única terapia,\ninfinitas respuestas.",
      intro:
        "QHHT es la técnica desarrollada por Dolores Cannon tras 50 años de experiencia como hipnoterapeuta. A través de un estado profundo de relajación, accedemos a tu subconsciente —lo que ella llamó «la esencia»— donde residen todas las respuestas y donde la sanación física, emocional y espiritual se vuelve posible.",
      blocks: [
        {
          tag: "01",
          title: "La entrevista",
          desc: "Antes de entrar en hipnosis, dedicamos tiempo a conocernos y a listar las preguntas que tu subconsciente responderá durante la sesión.",
        },
        {
          tag: "02",
          title: "Regresión guiada",
          desc: "Con una inducción hipnótica suave, visitas una o varias vidas o escenas significativas. Tu imaginación es el vehículo; yo solo te guío.",
        },
        {
          tag: "03",
          title: "Conversación con tu esencia",
          desc: "Llamamos al Subconsciente —la parte sabia de ti— para responder tus preguntas y realizar la sanación corporal y emocional que necesites.",
        },
        {
          tag: "04",
          title: "Integración",
          desc: "Al despertar compartimos lo vivido, contextualizamos los mensajes y te llevas una grabación completa de la sesión.",
        },
      ],
      highlights: [
        "Certificada en QHHT Nivel 2",
        "Sesión única de 4 horas mínimo",
        "Grabación incluida en audio",
        "Sesiones en español, inglés y chino",
      ],
    },
    process: {
      overline: "El camino",
      title: "Tres pasos para comenzar.",
      steps: [
        { n: "01", title: "Entrevista", desc: "Charla gratuita de 15 minutos por teléfono o videollamada para conocernos y comprender tus necesidades." },
        { n: "02", title: "Pedir cita", desc: "Una vez decidido trabajar juntos, reservamos la sesión por WhatsApp o email con antelación." },
        { n: "03", title: "Preparación", desc: "Antes de la sesión, anota las preguntas que quieres hacer a tu subconsciente. Dedica un momento de reflexión e intención." },
      ],
    },
    booking: {
      overline: "Reservar",
      title: "Reserva tu sesión\nen tres pasos.",
      intro: "Tras la entrevista gratuita, abona la reserva del 20 % y agenda la fecha de tu sesión QHHT.",
      step1: {
        tag: "01",
        title: "Entrevista gratuita",
        meta: "15 min · videollamada · gratis",
        desc: "Una conversación inicial para conocernos, resolver tus dudas y ver si QHHT es lo que estás buscando.",
        cta: "Agendar entrevista",
      },
      step2: {
        tag: "02",
        title: "Reserva tu plaza",
        meta: "44,40 € · 20 % de 222 €",
        desc: "Tras la entrevista, confirma tu sesión QHHT abonando el 20 % por PayPal. El 80 % restante se paga el día de la sesión.",
        cta: "Pagar 44,40 € por PayPal",
        note: "Pago seguro a través de PayPal. Recibirás email de confirmación.",
      },
      step3: {
        tag: "03",
        title: "Agendar tu sesión",
        meta: "4 h mínimo · presencial Barcelona",
        desc: "Una vez recibida la reserva, elige la fecha que mejor te encaje para tu sesión completa de QHHT.",
        cta: "Elegir fecha de sesión",
        lockedNote: "Disponible tras realizar el pago de la reserva.",
      },
      paidBanner: "✓ Pago recibido. Ya puedes elegir la fecha de tu sesión.",
    },
    about: {
      overline: "Quién soy",
      title: "Danwei Huang",
      role: "Terapeuta certificada QHHT",
      body:
        "Puente entre dos culturas, raíz china y corazón mediterráneo. Mi camino integra tradiciones milenarias de Oriente con metodologías occidentales contemporáneas: certificada en Quantum Healing Hypnosis Technique Nivel 2 con Julia Cannon, hija de Dolores Cannon y custodia oficial del método; formada en Hipnosis Introspectiva con Aurelio Mejía, en hipnosis ericksoniana, PNL y trabajo energético. Acompaño regresiones profundas y sesiones de transformación rápida. Cada terapia es una puerta distinta hacia el mismo origen: tu propia esencia. Trabajo en español, inglés y chino, en Barcelona y a distancia.",
      quote:
        "No hay límites, salvo los que tú mismo creas. Todo es posible. Solo estás limitado por tu propia imaginación.",
      quoteAuthor: "— Dolores Cannon",
      stats: [
        { n: "2012", d: "Acompañando con terapias" },
        { n: "2014", d: "Iniciada en hipnosis" },
        { n: "3", d: "Idiomas de atención" },
      ],
    },
    testimonial: {
      overline: "Testimonio",
      quote:
        "Después del tratamiento, el yo que tenía miedo de vivir junto a mi pareja desapareció. Ahora pienso conscientemente en la mujer que vi en mi sesión y me digo que yo misma debo controlar mis sentimientos y mi vida. Me siento muy satisfecha y muy feliz.",
      author: "Lili",
      location: "Barcelona",
    },
    contact: {
      overline: "Contacto",
      title: "Comienza tu viaje\nde regreso al origen.",
      intro:
        "Escríbeme por WhatsApp o correo, o reserva directamente tu entrevista gratuita de 15 minutos.",
      whatsapp: "Escribir por WhatsApp",
      call: "Reservar entrevista",
      email: "Enviar email",
      addressLabel: "Despacho",
      address: "C/ Dos de Maig 202 bajo 3",
      city: "08013 Barcelona",
      phoneLabel: "Teléfono",
      emailLabel: "Email",
      hoursLabel: "Horario",
      hours: "Lun – Vie · 13:30 – 18:30  ·  Sáb · 15:30 – 19:30",
      newsletter: {
        overline: "Mantente cerca",
        title: "Recibe novedades, talleres y meditaciones",
        desc: "Déjame tu correo y te avisaré de los próximos talleres de regresión grupal, meditaciones y mensajes esporádicos para acompañarte en tu camino.",
        placeholder: "tu@correo.com",
        cta: "Quiero recibir",
        privacy: "Sin spam · Nunca compartiré tu correo. Puedes darte de baja cuando quieras.",
        mailSubject: "Quiero recibir tus novedades",
        mailBody: "Hola Danwei, me gustaría recibir tus novedades, talleres y meditaciones. Mi correo es:",
      },
    },
    footer: {
      tagline: "Quantum Healing Hypnosis Technique en Barcelona",
      rights: "Todos los derechos reservados.",
    },
    group: {
      heroOverline: "Encuentros grupales · Barcelona",
      heroTitle: "Detente, escucha,\nregresa al origen.",
      heroBody:
        "Un taller monográfico de regresión grupal en grupo reducido para parar, centrarte y abrirte a una comprensión más amplia de ti misma.",
      heroNote: "Guiados por Danwei Huang · Hipnoterapeuta y terapeuta energética",
      backHome: "Volver al inicio",
      meditation: {
        tag: "01",
        overline: "Meditación grupal · cada lunes",
        title: "Meditación en Barcelona",
        kicker:
          "¿Te gustaría empezar la semana con más calma, claridad y energía? Te invito a una meditación grupal guiada, un espacio semanal para parar, reconectar contigo y cuidar tu bienestar.",
        kickerExtra:
          "A diferencia de otras meditaciones, es también una pequeña terapia grupal: cada semana resolvemos cosas juntos. Trabajamos las situaciones que te están afectando y nos llevamos recursos prácticos para gestionar el estrés y los retos del día a día.",
        idealTitle: "Ideal si…",
        ideal: [
          "Estás empezando a meditar y quieres una guía sencilla",
          "Te sientes estresado/a o con carga mental",
          "Buscas un espacio seguro para desconectar y cuidarte",
          "Quieres resolver situaciones que afectan tu bienestar",
          "Te interesa compartir la práctica en grupo",
          "Quieres incorporar la meditación a tu rutina semanal",
        ],
        when: "Cada lunes",
        time: "19:00 – 20:00",
        place: "C/ Dos de Maig 202, bajos 3 · 08013 Barcelona",
        intent:
          "Un encuentro cercano, accesible y sin juicios, abierto a todos los niveles.",
        priceTitle: "Aportación",
        priceFirst: "Primera sesión gratuita",
        priceSingle: "Sesión suelta · 20 €",
        priceMonthly: "Mensualidad · 65 €",
        ctaFree: "Reservar 1ª sesión gratis (WhatsApp)",
        ctaSingle: "Pagar sesión · 20 €",
        ctaMonthly: "Pagar mensualidad · 65 €",
        whatsappMessage:
          "Hola Danwei, me gustaría reservar plaza para la meditación grupal del próximo lunes (1ª sesión gratuita).",
      },
      workshop: {
        tag: "02",
        overline: "🌿 Taller monográfico",
        title: "Taller de Regresión Grupal",
        subtitle: "Viaje interior y conexión espiritual",
        kicker:
          "Basado en la práctica de Dolores Cannon, un espacio de exploración profunda donde podrás detenerte, centrarte y abrirte a una comprensión más amplia de ti misma. Combinamos enseñanza, práctica y experiencia directa, en un entorno cuidado y seguro para el trabajo interior en grupo.",
        benefitsTitle: "✨ Beneficios de la regresión grupal",
        benefits: [
          "Comprendes patrones que se repiten",
          "Liberas cargas emocionales del pasado",
          "Conectas con tu sabiduría interior",
          "Te sientes acompañado/a en grupo",
          "Expandes tu conciencia",
          "Reconoces tus recursos",
          "Integras partes de tu historia",
          "Recargas tu energía vital",
          "Elevas tu auto-conciencia",
        ],
        agendaTitle: "✨ ¿Qué se hace en el taller?",
        agenda: [
          "Tener una experiencia divertida y única",
          "Visitar una vida pasada",
          "Visitar a tu guía o ángel guardián",
          "Recibir un mensaje de tu guía",
          "Abrir un canal al universo infinito durante 3 días",
          "Aprender a visualizar",
          "Conectar con tu intuición",
          "Descubrir tu propia conexión con tu alma",
          "Profundizar en la autoconciencia",
          "Participar en preguntas y respuestas entre los viajes",
        ],
        agendaNote:
          "La regresión se vive como un viaje interno donde pueden surgir imágenes, sensaciones o comprensiones que te ayuden a ver con más claridad situaciones actuales, desde un lugar más amplio y consciente.",
        bringTitle: "Lo que necesitas para el taller",
        bring: [
          "Papel y bolígrafo para escribir lo que veas",
          "Un corazón y una mente abiertos, sin expectativas previas",
          "Evitar la cafeína o cualquier estimulante",
          "Confiar en lo que surja durante la sesión; no lo cuestiones. Si sientes que lo estás inventando, continúa igualmente",
          "Disposición a divertirte y disfrutar de la experiencia",
        ],
        forWhomTitle: "🌸 ¿Para quién es este taller?",
        forWhom:
          "Para personas que sienten el llamado a profundizar en su mundo interior, abrirse a una dimensión más espiritual de la vida y comprenderse desde un lugar más amoroso y expandido. No es necesario tener experiencia previa, solo disposición a explorar.",
        nextDateLabel: "Próxima fecha",
        nextDate: "",
        time: "3 horas · sábado por la tarde",
        place: "C/ Dos de Maig 202, bajos 3 · 08013 Barcelona",
        intent:
          "💫 Un espacio para reconectar, comprender y abrir nuevas perspectivas desde la calma y la conciencia.",
        priceLabel: "Aportación energética",
        price: "40 €",
        cta: "Reservar plaza · 40 €",
        ctaWhatsapp: "Preguntar por WhatsApp",
        whatsappMessage:
          "Hola Danwei, me gustaría reservar plaza en el próximo taller de regresión grupal.",
      },
    },
    whatsappMessage:
      "Hola Danwei, me gustaría agendar una entrevista gratuita de 15 minutos sobre una sesión de QHHT.",
  },

  en: {
    nav: {
      therapies: "Therapies",
      qhht: "QHHT",
      session: "The session",
      process: "Process",
      group: "Group",
      about: "About",
      contact: "Contact",
      book: "Book 15 min free call",
    },
    hero: {
      overline: "Quantum Healing Hypnosis · Barcelona",
      title: "Return to the origin.\nAwaken your inner light.",
      description:
        "Three paths to reconnect with yourself: Quantum Healing Hypnosis (QHHT), Energy Cleansing and Regressive Hypnosis.",
      primaryCta: "Free discovery call",
      secondaryCta: "See the therapies",
      location: "C/ Dos de Maig 202 · Barcelona",
    },
    yuan: {
      overline: "源 Yuan · The source",
      title: "The origin of all healing\nlives within you.",
      body:
        "源 (Yuan) is a Chinese word meaning «source» or «origin». In every QHHT session I guide you to discover your true power, reignite the divine light in your heart and see your reality from a higher state of consciousness. Emotion is the compass, the subconscious holds the answer.",
      pillars: [
        { title: "Awareness", desc: "Awaken to the truth that dwells within you." },
        { title: "Transformation", desc: "Release emotional blocks from the root." },
        { title: "Integration", desc: "Unite body, mind and spirit in the present." },
      ],
    },
    therapies: {
      overline: "Therapies",
      title: "Three paths,\none single origin.",
      headerCta: "Book 15 min · free call",
      intro:
        "Each session is a unique journey. Choose the path that resonates with where you are. Every therapy begins with a free 15-minute discovery call.",
      meditationAudio: null,
      payCta: "Pay session",
      bookCta: "Free discovery call",
      detailCta: "See details",
      items: [
        {
          tag: "01",
          title: "Quantum Healing Hypnosis (QHHT)",
          desc:
            "Technique developed by Dolores Cannon after 50 years of experience. We access the deep subconscious —the essence— where all answers reside and where physical, emotional and spiritual healing becomes possible.",
          meta: "4h minimum · In person · €222",
          highlights: ["QHHT Level 2 certified", "Audio recording included", "Deposit €44.40 (20%)"],
          primary: { type: "anchor", href: "#session", label: "See session details" },
          secondary: { type: "paypal", amount: "44.40", item: "QHHT session deposit 20 percent - Danwei Huang", label: "Book QHHT session · €44.40" },
        },
        {
          tag: "02",
          title: "Energy Cleansing",
          desc:
            "A subtle energy therapy that works on your informational field. We release blocks generated by repeated emotions, unresolved traumas or thoughts trapped in the body or in a space. Always done remotely: with your full name, date and place of birth — or the address if it's a venue — I connect with your essence or the energy gathered in the place. The session lasts about an hour; you can rest or continue with your day.",
          meta: "Remote only · €80",
          highlights: [
            "People, children and pets",
            "Homes, venues and businesses",
            "Done remotely",
            "Physical, emotional and energy relief",
            "Final summary message with what was worked",
          ],
          primary: { type: "paypal", amount: "80.00", item: "Energy Cleansing - Danwei Huang", label: "Pay session · €80" },
        },
        {
          tag: "03",
          title: "Regressive Hypnosis",
          desc:
            "Behind every fear, symptom or recurring pattern lies a past experience waiting to be understood. Through a gentle, conscious hypnosis we travel to that emotional root —in this life or in others— to heal and integrate it into the present from your adult perspective, without needing to relive the pain. It combines Ericksonian hypnosis, Aurelio Mejía's introspective hypnosis and NLP.",
          meta: "1 hour · Online or in person · €80",
          highlights: [
            "One topic or stage per session",
            "No reliving trauma with pain",
            "Understand your past from a new awareness",
            "Conscious and lasting transformation",
            "Online or in person",
          ],
          primary: { type: "paypal", amount: "80.00", item: "Regressive Hypnosis - Danwei Huang", label: "Pay session · €80" },
        },
      ],
    },
    qhht: {
      overline: "Quantum Healing Hypnosis Technique",
      title: "A single therapy,\nendless answers.",
      intro:
        "QHHT is the technique developed by Dolores Cannon over 50 years as a hypnotherapist. Through a deep state of relaxation we reach your subconscious — what she called «the essence» — where every answer resides and where physical, emotional and spiritual healing becomes possible.",
      blocks: [
        {
          tag: "01",
          title: "The interview",
          desc: "Before hypnosis, we spend time getting to know each other and listing the questions your subconscious will answer during the session.",
        },
        {
          tag: "02",
          title: "Guided regression",
          desc: "With a gentle hypnotic induction, you visit one or more past lives or meaningful scenes. Your imagination is the vehicle; I only guide you.",
        },
        {
          tag: "03",
          title: "Talk with your essence",
          desc: "We call upon the Subconscious — the wise part of you — to answer your questions and perform any body-level or emotional healing you need.",
        },
        {
          tag: "04",
          title: "Integration",
          desc: "Upon waking we share what came through, place the messages in context, and you take home a full audio recording of the session.",
        },
      ],
      highlights: [
        "QHHT Level 2 certified",
        "One single session of minimum 4 hours",
        "Audio recording included",
        "Sessions in Spanish, English and Chinese",
      ],
    },
    process: {
      overline: "The journey",
      title: "Three steps to begin.",
      steps: [
        { n: "01", title: "Discovery call", desc: "A free 15-minute call or video chat to get to know each other and understand your needs." },
        { n: "02", title: "Booking", desc: "Once we decide to work together, we schedule the session in advance via WhatsApp or email." },
        { n: "03", title: "Preparation", desc: "Before the session, write down the questions you want to ask your subconscious. Take a moment of reflection and intention." },
      ],
    },
    booking: {
      overline: "Book",
      title: "Book your session\nin three steps.",
      intro: "After the free discovery call, pay the 20 % deposit and schedule your QHHT session date.",
      step1: {
        tag: "01",
        title: "Free discovery call",
        meta: "15 min · video call · free",
        desc: "A first conversation to get to know each other, answer your questions and see if QHHT is what you're looking for.",
        cta: "Book discovery call",
      },
      step2: {
        tag: "02",
        title: "Reserve your spot",
        meta: "€44.40 · 20 % of €222",
        desc: "After the call, confirm your QHHT session by paying 20 % via PayPal. The remaining 80 % is paid on the day of the session.",
        cta: "Pay €44.40 with PayPal",
        note: "Secure payment via PayPal. You'll receive a confirmation email.",
      },
      step3: {
        tag: "03",
        title: "Pick your date",
        meta: "4h minimum · in person · Barcelona",
        desc: "Once the deposit is received, choose the date that works best for your full QHHT session.",
        cta: "Choose session date",
        lockedNote: "Available after the deposit is paid.",
      },
      paidBanner: "✓ Payment received. You can now pick your session date.",
    },
    about: {
      overline: "About",
      title: "Danwei Huang",
      role: "Certified QHHT practitioner",
      body:
        "A bridge between two cultures — Chinese roots, Mediterranean heart. My path weaves together ancient Eastern traditions and contemporary Western methods: certified in Quantum Healing Hypnosis Technique Level 2 with Julia Cannon, daughter of Dolores Cannon and official keeper of the method; trained in Introspective Hypnosis with Aurelio Mejía, and in Ericksonian hypnosis, NLP and energy work. I accompany deep regression journeys and fast-transformation sessions. Each therapy is a different door into the same source: your own essence. I work in Spanish, English and Chinese, in Barcelona and remotely.",
      quote:
        "There are no limitations, unless you create them yourselves. Anything is possible. You are only limited by your own imagination.",
      quoteAuthor: "— Dolores Cannon",
      stats: [
        { n: "2012", d: "Holding space through therapy" },
        { n: "2014", d: "Working with hypnosis" },
        { n: "3", d: "Languages" },
      ],
    },
    testimonial: {
      overline: "Testimonial",
      quote:
        "After the treatment, the part of me that was afraid to live with my partner disappeared. Now I consciously think about the woman I saw in my session and remind myself that I must be the one to control my feelings and my life. I feel deeply satisfied and happy.",
      author: "Lili",
      location: "Barcelona",
    },
    contact: {
      overline: "Contact",
      title: "Begin your journey\nback to the origin.",
      intro: "Reach me via WhatsApp or email, or book your free 15-minute discovery call directly.",
      whatsapp: "Message on WhatsApp",
      call: "Book discovery call",
      email: "Send email",
      addressLabel: "Office",
      address: "C/ Dos de Maig 202 bajo 3",
      city: "08013 Barcelona",
      phoneLabel: "Phone",
      emailLabel: "Email",
      hoursLabel: "Hours",
      hours: "Mon – Fri · 13:30 – 18:30  ·  Sat · 15:30 – 19:30",
      newsletter: {
        overline: "Stay close",
        title: "News, workshops and meditations",
        desc: "Leave me your email and I'll let you know about upcoming group regression workshops, meditations and occasional messages to walk this path with you.",
        placeholder: "your@email.com",
        cta: "Subscribe",
        privacy: "No spam · I'll never share your email. Unsubscribe anytime.",
        mailSubject: "I'd like to receive your updates",
        mailBody: "Hi Danwei, I'd like to receive your news, workshops and meditations. My email is:",
      },
    },
    footer: {
      tagline: "Quantum Healing Hypnosis Technique in Barcelona",
      rights: "All rights reserved.",
    },
    group: {
      heroOverline: "Group encounters · Barcelona",
      heroTitle: "Pause, listen,\nreturn to the origin.",
      heroBody:
        "A monographic group regression workshop in a small group, to stop, center yourself and open up to a wider understanding of who you are.",
      heroNote: "Guided by Danwei Huang · Hypnotherapist & energy therapist",
      backHome: "Back to home",
      meditation: {
        tag: "01",
        overline: "Group meditation · every Monday",
        title: "Meditation in Barcelona",
        kicker:
          "Would you like to start the week with more calm, clarity and energy? I invite you to a guided group meditation, a weekly space to pause, reconnect with yourself and care for your wellbeing.",
        kickerExtra:
          "Unlike other meditations, this is also a small group therapy: every week we actually work things out together. We address the situations affecting you and you leave with practical resources to handle stress and day-to-day challenges.",
        idealTitle: "Ideal if…",
        ideal: [
          "You are starting to meditate and want simple guidance",
          "You feel stressed or mentally overloaded",
          "You're looking for a safe space to switch off and care for yourself",
          "You want to work through situations affecting your wellbeing",
          "You'd like to share the practice in a group",
          "You want to bring meditation into your weekly routine",
        ],
        when: "Every Monday",
        time: "19:00 – 20:00",
        place: "C/ Dos de Maig 202, bajos 3 · 08013 Barcelona",
        intent: "A close, accessible, non-judgemental encounter, open to all levels.",
        priceTitle: "Contribution",
        priceFirst: "First session free",
        priceSingle: "Single session · €20",
        priceMonthly: "Monthly · €65",
        ctaFree: "Book first free session (WhatsApp)",
        ctaSingle: "Pay session · €20",
        ctaMonthly: "Pay monthly · €65",
        whatsappMessage:
          "Hi Danwei, I'd like to book a spot for next Monday's group meditation (first free session).",
      },
      workshop: {
        tag: "02",
        overline: "🌿 Monographic workshop",
        title: "Group Regression Workshop",
        subtitle: "Inner journey & spiritual connection",
        kicker:
          "Based on Dolores Cannon's practice, a space of deep exploration where you can stop, center yourself and open up to a wider understanding of who you are. We combine teaching, practice and direct experience in a careful and safe environment for inner work in a group.",
        benefitsTitle: "✨ Benefits of group regression",
        benefits: [
          "Understand recurring patterns",
          "Release emotional burdens from the past",
          "Connect with your inner wisdom",
          "Feel held within a group",
          "Expand your consciousness",
          "Recognise your resources",
          "Integrate parts of your story",
          "Recharge your vital energy",
          "Elevate your self-awareness",
        ],
        agendaTitle: "✨ What we do in the workshop",
        agenda: [
          "Have a fun and unique experience",
          "Visit a past life",
          "Visit your guide or guardian angel",
          "Receive a message from your guide",
          "Open a channel to the infinite universe for 3 days",
          "Learn to visualise",
          "Connect with your intuition",
          "Discover your own connection with your soul",
          "Deepen self-awareness",
          "Take part in Q&A between journeys",
        ],
        agendaNote:
          "Regression is experienced as an inner journey where images, sensations or insights may arise to help you see current situations more clearly, from a wider and more conscious place.",
        bringTitle: "What you need for the workshop",
        bring: [
          "Pen and paper to write down what you see",
          "An open heart and mind, with no expectations",
          "Avoid caffeine or any stimulants",
          "Trust whatever surfaces; don't question it. If it feels like you're making it up, keep going anyway",
          "Willingness to enjoy and have fun with the experience",
        ],
        forWhomTitle: "🌸 Who this workshop is for",
        forWhom:
          "For people who feel called to deepen their inner world, open up to a more spiritual dimension of life and understand themselves from a more loving, expansive place. No prior experience needed, only a willingness to explore.",
        nextDateLabel: "Next date",
        nextDate: "",
        time: "3 hours · Saturday afternoon",
        place: "C/ Dos de Maig 202, bajos 3 · 08013 Barcelona",
        intent:
          "💫 A space to reconnect, understand and open new perspectives from calm and consciousness.",
        priceLabel: "Energy contribution",
        price: "€40",
        cta: "Reserve spot · €40",
        ctaWhatsapp: "Ask via WhatsApp",
        whatsappMessage:
          "Hi Danwei, I'd like to reserve a spot in the next group regression workshop.",
      },
    },
    whatsappMessage:
      "Hi Danwei, I'd like to book a free 15-minute discovery call about a QHHT session.",
  },

  zh: {
    nav: {
      therapies: "疗愈",
      qhht: "QHHT",
      session: "疗愈流程",
      process: "预约步骤",
      group: "团体活动",
      about: "关于我",
      contact: "联系",
      book: "预约 15 分钟免费",
    },
    hero: {
      overline: "量子催眠疗法 · 巴塞罗那",
      title: "回归本源。\n唤醒内在光明。",
      description:
        "三条路径，回到你自己：量子催眠 QHHT、能量净化与回溯催眠。",
      primaryCta: "免费初诊",
      secondaryCta: "了解疗愈项目",
      location: "C/ Dos de Maig 202 · 巴塞罗那",
    },
    yuan: {
      overline: "源 · 本源",
      title: "一切疗愈的源头\n就在你之内。",
      body:
        "「源」意为源头、本源。在每一次 QHHT 疗愈中，我陪伴你发现真正的力量，重新点亮心中的神圣之光，从更高的意识层次看待现实。情绪是指南针，潜意识藏着答案。",
      pillars: [
        { title: "觉知", desc: "觉醒于内在的真相。" },
        { title: "转化", desc: "从根源释放情绪阻塞。" },
        { title: "整合", desc: "在当下整合身、心、灵。" },
      ],
    },
    therapies: {
      overline: "疗愈项目",
      title: "三条路径，\n同一个源头。",
      headerCta: "预约 15 分钟 · 免费视讯",
      intro: "每次疗愈都是独特的旅程。选择此刻与你共鸣的那条道路。所有疗愈都从 15 分钟免费初诊开始。",
      meditationAudio: {
        overline: "免费冥想音频",
        title: "引导冥想",
        desc: "在家就可以开始与自己重新连结 —— 收听我在 YouTube 上的免费引导冥想。",
        cta: "在 YouTube 收听",
        url: "https://www.youtube.com/@%E5%9B%9E%E5%BD%92%E8%BA%AB%E5%BF%83%E5%86%A5%E6%83%B3%E5%BC%95%E5%AF%BC",
      },
      payCta: "支付疗程",
      bookCta: "免费初诊",
      detailCta: "查看细节",
      items: [
        {
          tag: "01",
          title: "量子催眠 QHHT",
          desc:
            "由 Dolores Cannon 历经五十年发展的技术。透过深层潜意识（本源）获得答案，让身体、情绪与灵魂的疗愈成为可能。",
          meta: "至少 4 小时 · 现场 · 222 €",
          highlights: ["QHHT 二级认证", "完整录音", "订金 44,40 €（20%）"],
          primary: { type: "anchor", href: "#session", label: "查看疗愈细节" },
          secondary: { type: "paypal", amount: "44.40", item: "QHHT session deposit 20 percent - Danwei Huang", label: "预约 QHHT 疗程 · 44,40 €" },
        },
        {
          tag: "02",
          title: "能量净化",
          desc:
            "一种细致的能量疗法，作用于你的信息场。释放因反复情绪、未化解创伤或被困念头而形成的阻塞 —— 无论是在身体或空间中。完全远距进行：透过你的全名、出生日期与出生地（若是空间则提供地址），我与你的本源或场所累积的能量连结。疗愈约一小时，你可以休息或继续日常活动。",
          meta: "仅远距 · 80 €",
          highlights: [
            "适用于人、儿童与宠物",
            "家宅、店铺与公司",
            "远距进行",
            "身体、情绪与能量层面的舒缓",
            "结束后提供疗愈讯息总结",
          ],
          primary: { type: "paypal", amount: "80.00", item: "Energy Cleansing - Danwei Huang", label: "支付疗程 · 80 €" },
        },
        {
          tag: "03",
          title: "回溯催眠",
          desc:
            "每一个恐惧、症状或反复出现的模式背后，都藏着一段等待被理解的过往经验。透过温和而清醒的催眠，我们一同走向那份情绪的根源 —— 此生或前世 —— 以你今日成熟的视角去疗愈、去整合到当下，无需重新经历痛苦。结合艾瑞克森催眠、Aurelio Mejía 的内观催眠与 NLP（神经语言程式学）。",
          meta: "1 小时 · 线上或现场 · 80 €",
          highlights: [
            "单次处理一个主题或阶段",
            "不重新经历创伤的痛苦",
            "以新的意识理解过去",
            "清醒且持久的转化",
            "线上或现场",
          ],
          primary: { type: "paypal", amount: "80.00", item: "Regressive Hypnosis - Danwei Huang", label: "支付疗程 · 80 €" },
        },
      ],
    },
    qhht: {
      overline: "Quantum Healing Hypnosis Technique",
      title: "一种疗法，\n无数答案。",
      intro:
        "QHHT 是 Dolores Cannon 经过五十年临床经验发展的量子催眠技术。透过深度放松，我们与你的潜意识 ——她称之为「本源」—— 相遇，在那里，所有答案已经存在，身体、情绪与灵魂的疗愈得以发生。",
      blocks: [
        {
          tag: "01",
          title: "初次会谈",
          desc: "进入催眠前，我们深入认识彼此，并列出你希望潜意识在疗愈中回答的问题。",
        },
        {
          tag: "02",
          title: "引导回溯",
          desc: "以温和的催眠引导，你会走入一世或多段重要场景。你的想象是载体，我只负责陪伴。",
        },
        {
          tag: "03",
          title: "与本源对话",
          desc: "召请潜意识 ——你内在最有智慧的部分—— 回答你的问题，进行身体与情绪层面的疗愈。",
        },
        {
          tag: "04",
          title: "整合",
          desc: "醒来后我们一起回顾所见，解读讯息，并将完整的录音交到你手上。",
        },
      ],
      highlights: [
        "QHHT 二级认证",
        "单次疗愈 至少 4 小时",
        "完整录音随疗愈提供",
        "中文 / 西班牙语 / 英文服务",
      ],
    },
    process: {
      overline: "旅程",
      title: "三个步骤开启疗愈。",
      steps: [
        { n: "01", title: "初次会谈", desc: "15 分钟免费电话或视频，相互认识并了解你的需求。" },
        { n: "02", title: "预约", desc: "决定合作后，透过 WhatsApp 或邮件提前预约疗程。" },
        { n: "03", title: "准备", desc: "疗愈前写下希望向潜意识提出的问题，静心片刻，设下意图。" },
      ],
    },
    booking: {
      overline: "立即预约",
      title: "三步完成\n你的 QHHT 预约。",
      intro: "免费初诊后，支付 20% 订金并选择正式疗愈的日期。",
      step1: {
        tag: "01",
        title: "免费初次会谈",
        meta: "15 分钟 · 视频通话 · 免费",
        desc: "首次对话，相互认识、解答你的疑问，确认 QHHT 是否适合你。",
        cta: "预约初诊",
      },
      step2: {
        tag: "02",
        title: "支付订金",
        meta: "44,40 € · 222 € 的 20%",
        desc: "初诊后透过 PayPal 支付 20% 订金确认疗程；余下的 80% 在疗愈当天支付。",
        cta: "用 PayPal 支付 44,40 €",
        note: "PayPal 安全支付，付款后将收到确认邮件。",
      },
      step3: {
        tag: "03",
        title: "选择疗愈日期",
        meta: "至少 4 小时 · 巴塞罗那现场",
        desc: "订金到账后，选择最适合你的 QHHT 完整疗程日期。",
        cta: "选择疗愈日期",
        lockedNote: "完成订金支付后开放。",
      },
      paidBanner: "✓ 已收到付款，现在可以选择你的疗愈日期。",
    },
    about: {
      overline: "关于我",
      title: "黄丹薇 · Danwei Huang",
      role: "QHHT 量子催眠认证治疗师",
      body:
        "两种文化之间的桥梁 —— 中国血脉，地中海心灵。我的修习之路将东方千年传统与西方当代方法相互编织：师承 Dolores Cannon 之女、方法正统传人 Julia Cannon，取得 QHHT 量子催眠二级认证；师承 Aurelio Mejía 的内观催眠，并修习艾瑞克森催眠、NLP 与能量工作。我陪伴你的，可以是深度回溯之旅或快速转化的疗愈。每一种疗愈，都是通往同一个本源 —— 你的内在本质 —— 的一道门。中文、西班牙语与英文，巴塞罗那现场或远距进行。",
      quote:
        "世上没有界限，除非你亲手创造它。一切皆有可能。你唯一的限制，是自己的想象力。",
      quoteAuthor: "— Dolores Cannon",
      stats: [
        { n: "2012", d: "陪伴疗愈之始" },
        { n: "2014", d: "投入催眠工作" },
        { n: "3", d: "服务语言" },
      ],
    },
    testimonial: {
      overline: "见证",
      quote:
        "疗愈之后，那个害怕与伴侣共同生活的自己消失了。我会有意识地想起在催眠中看见的那个女人，提醒自己要能主导自己的感受与人生。我非常满足，也非常快乐。",
      author: "Lili",
      location: "巴塞罗那",
    },
    contact: {
      overline: "联系",
      title: "开启回到本源\n的旅程。",
      intro: "透过 WhatsApp 或邮件与我联络，或直接预约 15 分钟的免费初诊。",
      whatsapp: "WhatsApp 咨询",
      call: "预约初诊",
      email: "发送邮件",
      addressLabel: "地址",
      address: "C/ Dos de Maig 202 bajo 3",
      city: "08013 巴塞罗那",
      phoneLabel: "电话",
      emailLabel: "邮箱",
      hoursLabel: "时间",
      hours: "周一 – 周五 · 13:30 – 18:30  ·  周六 · 15:30 – 19:30",
      newsletter: {
        overline: "保持联系",
        title: "工作坊 · 冥想 · 心灵讯息",
        desc: "留下你的邮箱，我会在下次团体回溯工作坊、引导冥想及偶尔的心灵讯息时通知你。",
        placeholder: "你的邮箱",
        cta: "我想收到",
        privacy: "不发垃圾邮件 · 绝不会分享你的邮箱，随时可以退订。",
        mailSubject: "我想收到你的讯息",
        mailBody: "你好 Danwei，我想收到你的工作坊、冥想及心灵讯息。我的邮箱是：",
      },
    },
    footer: {
      tagline: "巴塞罗那量子催眠疗法 QHHT",
      rights: "版权所有。",
    },
    group: {
      heroOverline: "团体共修 · 巴塞罗那",
      heroTitle: "停下来，倾听，\n回到本源。",
      heroBody:
        "团体小型回溯工作坊：在群体中停下、回到中心，开启对自我的更广阔理解。",
      heroNote: "由黄丹薇带领 · 催眠与能量治疗师",
      backHome: "返回首页",
      meditation: {
        tag: "01",
        overline: "团体冥想 · 每周一",
        title: "巴塞罗那团体冥想",
        kicker:
          "想要在更平静、清明、有能量的状态中开启一周吗？欢迎参加每周一晚的团体冥想，让自己暂停、与自己重新连结、照顾自己的身心。",
        kickerExtra:
          "和一般的冥想不同，这也是一场小型的团体疗愈：每周我们一起真正去解决问题。我们共同探讨正在影响你的情境，并带走可以面对压力与日常挑战的实用资源。",
        idealTitle: "适合你，如果…",
        ideal: [
          "刚开始接触冥想，希望有简单的引导",
          "感到压力大或思绪繁多",
          "想要一个安全的空间放下与休息",
          "希望疗愈影响你身心的处境",
          "愿意在群体中分享练习",
          "想把冥想加入每周的生活节奏",
        ],
        when: "每周一",
        time: "19:00 – 20:00",
        place: "C/ Dos de Maig 202, bajos 3 · 08013 巴塞罗那",
        intent: "亲切、平易、无评判，欢迎所有程度的朋友。",
        priceTitle: "能量贡献",
        priceFirst: "首次免费",
        priceSingle: "单次 · 20 €",
        priceMonthly: "月票 · 65 €",
        ctaFree: "WhatsApp 预约首次免费",
        ctaSingle: "支付单次 · 20 €",
        ctaMonthly: "支付月票 · 65 €",
        whatsappMessage:
          "你好 Danwei，我想预约下周一的团体冥想（首次免费）。",
      },
      workshop: {
        tag: "02",
        overline: "🌿 主题工作坊",
        title: "团体回溯工作坊",
        subtitle: "内在旅程与灵性连结",
        kicker:
          "基于 Dolores Cannon 的实践，这是一个深度探索的空间，让你停下来、回到中心，对自己有更广阔的理解。结合教学、练习与直接体验，在被守护的安全环境中进行团体内在工作。",
        benefitsTitle: "✨ 团体回溯的益处",
        benefits: [
          "理解一再重复的模式",
          "释放过往的情绪重担",
          "与你的内在智慧连结",
          "在群体中感到陪伴",
          "扩展意识",
          "看见自己的资源",
          "整合你生命故事的片段",
          "充电生命能量",
          "提升自我觉知",
        ],
        agendaTitle: "✨ 工作坊会做些什么？",
        agenda: [
          "拥有有趣而独特的体验",
          "造访一段过去世",
          "拜访你的指导灵或守护天使",
          "接收来自指导灵的讯息",
          "为你打开通往无限宇宙的通道（持续 3 天）",
          "学习视觉化",
          "与直觉连结",
          "发现你与灵魂之间的连结",
          "深化自我觉知",
          "在每段旅程间参与问答",
        ],
        agendaNote:
          "回溯是一段内在旅程：可能浮现影像、感受或领悟，帮助你以更广阔、更清明的方式看见当下的处境。",
        bringTitle: "工作坊需要准备",
        bring: [
          "纸和笔，记录所见",
          "敞开的心与开放的心智，无预设期待",
          "避免咖啡因或任何刺激物",
          "信任在过程中浮现的一切，不去质疑；如果觉得是自己编造的，也请继续",
          "带着轻盈与享受的心情",
        ],
        forWhomTitle: "🌸 这个工作坊适合谁？",
        forWhom:
          "适合感受到内在召唤、想要深化内在世界、向更具灵性的生命维度敞开、愿意以更慈爱与开阔的方式理解自己的人。无需先前经验，只需一颗愿意探索的心。",
        nextDateLabel: "下次日期",
        nextDate: "",
        time: "共 3 小时 · 周六下午",
        place: "C/ Dos de Maig 202, bajos 3 · 08013 巴塞罗那",
        intent: "💫 在平静与觉知中重新连结、理解，并开启新的视角。",
        priceLabel: "能量贡献",
        price: "40 €",
        cta: "预约名额 · 40 €",
        ctaWhatsapp: "WhatsApp 咨询",
        whatsappMessage:
          "你好 Danwei，我想预约下次的团体回溯工作坊。",
      },
    },
    whatsappMessage:
      "你好 Danwei，我想预约一次 15 分钟的免费 QHHT 初诊会谈。",
  },
};

export const CONTACT = {
  phone: "+34 620 639 413",
  phoneClean: "34620639413",
  email: "danweihuangterapias@gmail.com",
  address: "C/ Dos de Maig 202 bajo 3, 08013 Barcelona",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=C%2F+Dos+de+Maig+202%2C+08013+Barcelona",
  instagram: "https://www.instagram.com/danweihuangterapias/",
  facebook: "https://www.facebook.com/danweihuangenergia",
  xiaohongshu: "https://www.xiaohongshu.com/user/profile/317829800",
};

// === BOOKING CONFIG ============================================
// Replace the URLs below with your real public Calendly links.
// To get them: log in at calendly.com → Event Types → Copy link.
// =================================================================
export const BOOKING = {
  // Step 1 — Free discovery call (URL slug shows "30min" but actual call is 15 min)
  calendlyDiscovery:
    "https://calendly.com/danweihuangterapias/30min",
  // Step 3 — QHHT full session (4h+), shown after deposit paid.
  // TODO: replace with dedicated event URL when Danwei creates "Sesión QHHT" in Calendly.
  // Currently points to her main Calendly profile so the customer sees all available events.
  calendlyQhht:
    "https://calendly.com/danweihuangterapias",
  // Step 2 — PayPal deposit (20% of €222 = €44.40)
  paypalEmail: "holahuang@hotmail.com",
  paypalAmount: "44.40",
  currency: "EUR",
  sessionPriceTotal: 222,
  depositPercent: 20,
};

// Direct PayPal "Buy Now" classic URL (no API keys needed)
// After payment PayPal can redirect back via the `return` URL parameter.
export function buildPaypalUrl(returnUrl, { amount, itemName } = {}) {
  const params = new URLSearchParams({
    cmd: "_xclick",
    business: BOOKING.paypalEmail,
    item_name: itemName || "Reserva sesion QHHT - Danwei Huang",
    amount: amount || BOOKING.paypalAmount,
    currency_code: BOOKING.currency,
    no_shipping: "1",
    rm: "0",
  });
  if (returnUrl) {
    params.set("return", returnUrl);
  }
  return `https://www.paypal.com/cgi-bin/webscr?${params.toString()}`;
}

export const MEDIA = {
  hero:
    "https://customer-assets.emergentagent.com/job_hypnosis-therapy-bcn/artifacts/5b3zcorg_IMG_1655%20%281%29.jpg",
  candles:
    "https://customer-assets.emergentagent.com/job_hypnosis-therapy-bcn/artifacts/5vet3d6x_Wei%20-%209-1.jpeg",
  // Zen / oriental imagery with warm golden tones
  yuanNature:
    "https://images.unsplash.com/photo-1528360983277-13d401cdc186?auto=format&fit=crop&w=1400&q=80",
  bamboo:
    "https://images.unsplash.com/photo-1502139214982-d0ad755818d8?auto=format&fit=crop&w=1400&q=80",
  zenStones:
    "https://images.unsplash.com/photo-1507608616759-54f48f0af0ee?auto=format&fit=crop&w=1400&q=80",
  mistMountain:
    "https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=1600&q=80",
  blossom:
    "https://images.unsplash.com/photo-1522383225653-ed111181a951?auto=format&fit=crop&w=1400&q=80",
  candlelight:
    "https://images.unsplash.com/photo-1518495973542-4542c06a5843?auto=format&fit=crop&w=1400&q=80",
  lotus:
    "https://images.unsplash.com/photo-1490604001847-b712b0c2f967?auto=format&fit=crop&w=1400&q=80",
  pathOpen:
    "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?auto=format&fit=crop&w=1400&q=80",
  pastLives:
    "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?auto=format&fit=crop&w=1400&q=80",
};
